<script lang="ts">
	import '$lib/components/cms/shop.css';
	import { datadogRum } from '@datadog/browser-rum';
	import Breadcrumbs from '$lib/components/Breadcrumbs.svelte';
	import { initMap } from '$lib/components/cms';
	import Title from '$lib/components/Title.svelte';

	import type { CMSPageData } from './page.cms';

	datadogRum.setViewName('/cms-page');

	const { data }: { data: CMSPageData } = $props();

	$effect(() => {
		if (data.identifier === 'shop') initMap();
	});
</script>

<div class="full-container mx-auto flex flex-col justify-center px-5">
	<Breadcrumbs class="mb-4" />

	<div class={['prose prose-cms-content', { 'cms-shop': data.identifier === 'shop' }]}>
		<Title>{data.title}</Title>

		<div data-sveltekit-reload>
			{@html data.content.content}
		</div>
	</div>
</div>
